/**
 * @project: certiapp-nuxt
 * @file:    \store\user.js
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 4th July 2022
 * Last Modified: Thu Jul 13 2023
 **/

import { uuid } from "vue-uuid"

export const state = () => ({})

export const mutations = {}

export const actions = {
  //+-------------------------------------------------
  // can()
  // Returns true or false for the current user to access a module
  // based on roles
  // -----
  // Created on Mon Jul 04 2022
  //+-------------------------------------------------
  async can({ rootState }, params) {
    let can = false
    let auth = $nuxt.$auth.user.permisos
    console.warn(
      '🔔 WIP (Permisos de usuario)',
      auth.filter((item) => {
        return item.modulo === params.module
      })
    )
    //return true

    let modul = auth.filter((item) => {
      //if (params.submodule)
      //  return item.modulo == params.module && item.submodulo == params.submodule
      //else return item.modulo == params.module
      return item.modulo == params.module
    })
    //console.log('modul',modul)

    // let modules = auth.filter((item) => {
    //   if (params.submodule)
    //     return item.modulo == params.module && item.submodulo == params.submodule
    //   else return item.modulo == params.module
    // })

    if (!modul) return { can: false, details: params }
    if (params.return == 'all' || !params.action) {
      if (Array.isArray(modul)) {
        //attach all permissions in one object
        let canConfig = []
        modul.forEach((item) => {
          canConfig.push(item.canConfig)
        })
        //convert to array of one object
        canConfig = Object.assign({}, ...canConfig)
        //console.log('canConfig',canConfig)
        modul.canConfig = canConfig
      }
      return modul.canConfig
    }

    if (modul.canConfig[params.action] && modul.canConfig[params.action] == true) {
      can = true
    }

    if (can == false) {
      console.warn(
        '🗝️',
        'No se permite el acceso al usuario para el modulo:',
        params.module + ' - ' + params.action,
        modul.canConfig,
        $nuxt.$auth.user
      )
    }
    return can
  },
  async altabaja({ rootState }, user) {
    rootState.loading = true

    // Define la propiedad correcta según tipo de trámite
    const data = {
      uuid: user.uuid,
      observaciones: user.observaciones,
    }

    if (user.tipo_tramite === 'baja') {
      data.accesoHasta = user.fecha
    } else {
      data.accesoDesde = user.fecha
    }

    try {
      await this.$axios.patch(`usuarios/${user.uuid}/altabaja`, data, {
        headers: { 'Content-Type': 'application/merge-patch+json' },
      })
    } finally {
      rootState.loading = false
    }
  },
}
